// extracted by mini-css-extract-plugin
export var container = "bc_k";
export var device = "bc_dM";
export var deviceContainer = "bc_dL";
export var icon = "bc_bz";
export var icons = "bc_bS";
export var image = "bc_d";
export var logo = "bc_bn";
export var model = "bc_dN";
export var section = "bc_b";